import { useEffect, useRef, useState } from "react";

export default function useComponentVisible<T extends HTMLElement>(initialIsVisible: boolean) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const targetAreaRef = useRef<T | null>(null);

  useEffect(() => {
    setIsComponentVisible(initialIsVisible);
  }, [initialIsVisible]);

  const handleClick = (event: MouseEvent) => {
    if (
      targetAreaRef.current &&
      !targetAreaRef.current.contains(event.target as Node)
    ) {
      setIsComponentVisible(false);
    }
  };

  const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown, true);
    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("keydown", handleKeydown, true);
      document.removeEventListener("click", handleClick, true);
    };
  }, []);

  return { targetAreaRef, isComponentVisible, setIsComponentVisible };
}
